import { CreateRoleDto } from "../../domain/roles/roles"
import { TenantAccountDTO, TenantDTO, TenantFormState, TenantImageUrls, TenantUpdateImagesDTO } from "./tenantsModel"

export type TenantFormAction =
  | { type: 'SET_TENANT_FIELD', fieldName: keyof TenantDTO, payload: any }
  | { type: 'RESET_TENANT_DATA', payload: TenantDTO }
  | { type: 'SET_IMAGES', payload: TenantUpdateImagesDTO }
  | { type: 'SET_SERVER_IMAGES', payload: TenantImageUrls }
  | { type: 'SET_NEW_ROLES', payload: CreateRoleDto[] }
  | { type: 'RESET_ROLES' }
  | { type: 'SET_ADMIN_ACCOUNT_FIELD', fieldName: keyof TenantAccountDTO, payload: any }
  | { type: 'SET_IS_ADMIN_ACCOUNT_EMAIL_AVAILABLE', payload: boolean }
  | { type: 'SET_CLOSE_UNBILLABLE_GAPS', payload: boolean }
  | { type: 'RESET_FORM', payload: TenantFormState }

export function tenantFormReducer(state: TenantFormState, action: TenantFormAction): TenantFormState {
  switch (action.type) {
    case 'SET_TENANT_FIELD':
      return { ...state, tenant: { ...state.tenant, [action.fieldName]: action.payload } }
    case 'RESET_TENANT_DATA':
      return { ...state, tenant: action.payload }
    case 'SET_IMAGES':
      return { ...state, images: action.payload }
    case 'SET_SERVER_IMAGES':
      return { ...state, serverImages: action.payload }
    case 'SET_NEW_ROLES':
      return { ...state, roles: action.payload }
    case 'RESET_ROLES':
      return { ...state, roles: [] }
    case 'SET_ADMIN_ACCOUNT_FIELD':
      return { ...state, adminAccount: { ...state.adminAccount, [action.fieldName]: action.payload } }
    case 'SET_IS_ADMIN_ACCOUNT_EMAIL_AVAILABLE':
      return { ...state, isAdminAccountEmailAvailable: action.payload }
    case 'SET_CLOSE_UNBILLABLE_GAPS':
      return { ...state, tenant: { ...state.tenant, closeUnbillableGaps: action.payload } }
    case 'RESET_FORM':
      return { ...action.payload }
    default:
      return state
  }
}